/** The misheard words picked in a dictation: whitespace-token indices,
 *  `from` inclusive, `to` exclusive (the range Rust takes). */
export type WordSelection = { from: number; to: number };

/** A click on word `index`: a word right next to the selection extends it,
 *  any other word starts a new selection. */
export function selectWord(
  selection: WordSelection | null,
  index: number,
): WordSelection {
  if (selection && index === selection.from - 1) {
    return { from: index, to: selection.to };
  }
  if (selection && index === selection.to) {
    return { from: selection.from, to: index + 1 };
  }
  return { from: index, to: index + 1 };
}

export const isSelected = (selection: WordSelection | null, index: number) =>
  selection !== null && index >= selection.from && index < selection.to;
